import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ToggleService {

    private isToggledTheme = new BehaviorSubject<boolean>(false);
    private isToggledSideBar = new BehaviorSubject<boolean>(false);

    get isToggledTheme$() {
        return this.isToggledTheme.asObservable();
    }

    get isToggledSideBar$() {
      return this.isToggledSideBar.asObservable();
    }

    toggleTheme() {
      const newThemeState = !this.isToggledTheme.value;
      this.isToggledTheme.next(newThemeState);
      localStorage.setItem('isDarkTheme', JSON.stringify(newThemeState));
    }

    toggleSideBar() {
      this.isToggledSideBar.next(!this.isToggledSideBar.value);
    }

    closeSideBar() {
      this.isToggledSideBar.next(false);
    }

    // Dark Mode
    private isDarkTheme: boolean;

    constructor() {
      // Dark Mode
      const storedTheme = localStorage.getItem('isDarkTheme');
      const isDarkTheme = storedTheme ? JSON.parse(storedTheme) : false;
      this.isToggledTheme.next(isDarkTheme); // Initialize the theme BehaviorSubject
    }

    // Dark Mode
    // toggleTheme() {
    //     this.isDarkTheme = !this.isDarkTheme;
    //     localStorage.setItem('isDarkTheme', JSON.stringify(this.isDarkTheme));
    // }
    isDark() {
        return this.isToggledTheme.value;
    }

}
